import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IControlProps } from '../types/IFormSettings';
import { controlSelector } from '../selectors/formBuilder.selector';
import { updateFormControlValueAction } from '../actions/formActions';

function Slider({ controlName, formName }: IControlProps) {
    const { value, minValue, maxValue, stepping = 1 } = useSelector(
        controlSelector(formName, controlName),
    );
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState(value);
    const [leftColor, setLeftColor] = useState('');
    const [rightColor, setRightColor] = useState('');

    const getValueInRange = (input: number) => {
        if (minValue !== undefined && input < minValue) {
            return minValue;
        }

        if (maxValue !== undefined && input > maxValue) {
            return maxValue;
        }

        return input;
    };

    const roundToStepping = (input: number) => {
        if (input === inputValue || input % stepping === 0) {
            return getValueInRange(input);
        }

        if (input > inputValue) {
            return getValueInRange(Number(inputValue) + Number(stepping));
        }

        return getValueInRange(Number(inputValue) - Number(stepping));
    };

    const sliderDispatch = (input: number) => {
        dispatch(
            updateFormControlValueAction({
                formName,
                value: input,
                controlName,
            }),
        );
    };

    const onChangeHandler = (input: Number) => {
        const newVal = roundToStepping(Number(input));
        sliderDispatch(newVal);
        setInputValue(newVal);
    };

    const onDecrease = () => {
        const newVal = roundToStepping(Number(inputValue) - 1);
        sliderDispatch(newVal);
        setInputValue(newVal);
    };

    const onIncrease = () => {
        const newVal = roundToStepping(Number(inputValue) + 1);
        sliderDispatch(newVal);
        setInputValue(newVal);
    };

    const getBackground = () => {
        let percent = 100;
        if(minValue && maxValue) {
            percent = ((inputValue - minValue) / (maxValue - minValue)) * 100;
        }
        return `linear-gradient(to right, ` + leftColor + ` ` + percent.toString() + `%, ` + rightColor + ` ` + percent.toString() + `%)`;
    }

    const setColors = () => {
		setLeftColor('#6a572b') // N25 Brown
		setRightColor('#7d6630') // N25 Olive
	}

    if(leftColor.length === 0) {
        setColors();
    }

    return (
        <div>
            <span className="slider-input-parent">
                <button type="button" onClick={onDecrease} className="btn-decrease">
                    -
                </button>
                <input
                    className="form-control slider-input"
                    id={controlName}
                    type="number"
                    min={minValue}
                    max={maxValue}
                    readOnly={true}
                    value={inputValue || minValue}
                    name={controlName}
                    onChange={(e) => onChangeHandler(Number(e.currentTarget.value))}
                    onBlur={(e) => onChangeHandler(Number(e.currentTarget.value))}
                />
                <button type="button" onClick={onIncrease} className="btn-increase">
                    +
                </button>
            </span>
            <span
                className="range-parent"
                style={{
                    backgroundImage: getBackground(),
                }}
            >
                <input
                    id={controlName}
                    className="slider-control"
                    type="range"
                    name={controlName}
                    min={minValue}
                    max={maxValue}
                    step={stepping}
                    value={inputValue || minValue}
                    onChange={(e) => onChangeHandler(Number(e.currentTarget.value))}
                />
            </span>

            <div className="col-12 values">
                <div className="row">
                    <div className="col-6 min">
                        <div>{minValue}</div>
                    </div>
                    <div className="col-6 max">
                        <div>{maxValue}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Slider;
